import React from "react";

import { InputProps, TextInput } from "../../controls";
import FieldError from "../FieldError";
import FieldLabel from "../FieldLabel";
import FieldLayout from "../FieldLayout";

type Props = InputProps<string> & {
  type: "text" | "email" | "password";
  label: React.ReactNode;
  name: string;
  showError?: boolean;
  error?: React.ReactNode;
  dataTest?: string;
};

export default function FormTextInput(props: Props) {
  const {
    name,
    label,
    error,
    dataTest: dataTestValue,
    showError = false,
    ...inputProps
  } = props;

  const dataTest = makeDataTest(dataTestValue);

  return (
    <FieldLayout showError={showError}>
      {{
        label: (
          <FieldLabel htmlFor={name} dataTest={dataTest("label")}>
            {label}
          </FieldLabel>
        ),
        field: (
          <TextInput
            id={name}
            name={name}
            error={showError}
            dataTest={dataTest("field")}
            {...inputProps}
          />
        ),
        error: <FieldError dataTest={dataTest("error")}>{error}</FieldError>
      }}
    </FieldLayout>
  );
}

const makeDataTest = (dataTest?: string) => (
  type: "label" | "field" | "error"
) => (dataTest ? `${dataTest}-${type}` : undefined);
